import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'
import { useQueryKeys } from '../hooks'
import { cacheDuration } from '../shared'
import { ExtendedBridgeMessage } from '~/types/bridge-message'
import { getApiClient } from '../stores'

type MessageQueryProps = {
  messageId: string
  workspaceId: string
  botId: string
}
export const messageQueryOptions = ({ messageId, ...props }: MessageQueryProps) => {
  const { getMessage } = useQueryKeys()
  const client = getApiClient(props)
  return queryOptions({
    staleTime: cacheDuration.long,
    queryKey: getMessage(messageId),
    queryFn: async () => client.getMessage({ id: messageId }),
    meta: {
      suppressError: true,
    },
  })
}

export const listHitlMessagesInfiniteQueryOptions = ({
  workspaceId,
  botId,
  conversationId,
}: {
  workspaceId: string
  botId: string
  conversationId: string
}) => {
  const { listHitlMessages } = useQueryKeys()
  return infiniteQueryOptions({
    staleTime: cacheDuration.short,
    queryKey: listHitlMessages(workspaceId, botId, conversationId),
    queryFn: async ({ pageParam }) => {
      const { messages, meta } = await getApiClient({ workspaceId, botId })
        .listMessages({ conversationId, nextToken: pageParam })
        .catch((e) => {
          console.error('Failed to fetch events', e)
          return { messages: [], meta: { nextToken: null } }
        })

      return {
        messages: messages as ExtendedBridgeMessage[],
        meta,
      }
    },
    getNextPageParam: (lastPage) => {
      return lastPage.meta.nextToken
    },
    initialPageParam: undefined as string | undefined,
  })
}
